import React, { useState } from 'react';
import CookieSettings from './CookieSettings';

const Footer = () => {
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  return (
  <footer className="bg-gray-700 text-white mt-12">
    <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-lg font-semibold mb-4">About Us</h3>
          <p className="text-gray-300">Your trusted partner in small business technology solutions</p>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">Contact</h3>
          <p className="text-gray-300">Phone: (231) 941-2100</p>
          <a 
            href="https://www.google.com/maps/dir/?api=1&destination=954+Business+Park+Dr+%236+Traverse+City%2C+MI+49686" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-300 underline hover:text-white transition-colors duration-200"
          >
            954 Business Park Dr #6 Traverse City, MI 49686
          </a>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">Office Hours</h3>
          <ul className="text-gray-300">
            <li className="font-bold">Monday-Friday, 8:30AM-5PM</li>
            <li>24-Hour On-Call Emergency Line available for our customers, with a live human answering the phone every time - no AI chatbots here!</li>
          </ul>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
          <div className="space-x-6 flex flex-row items-center">
            <a 
              href="https://www.linkedin.com/company/terrapin-networks/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-300 hover:text-white transition-colors duration-200"
              aria-label="Visit Terrapin Networks on LinkedIn"
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a 
              href="https://x.com/TerrapinNtwrks" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-300 hover:text-white transition-colors duration-200"
              aria-label="Follow Terrapin Networks on X"
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a 
              href="https://www.facebook.com/TerrapinDotTech/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-300 hover:text-white transition-colors duration-200"
              aria-label="Visit Terrapin Networks on Facebook"
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="mt-8 pt-6 border-t border-gray-600">
        <div className="flex flex-col sm:flex-row justify-between items-center">
          <p className="text-center text-sm text-gray-400">
            © {new Date().getFullYear()} Terrapin Networks. All Rights Reserved.
          </p>
          <div className="mt-2 sm:mt-0">
            <button
              onClick={() => setShowCookieSettings(true)}
              className="text-sm text-gray-400 hover:text-white underline transition-colors"
            >
              Cookie Settings
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <CookieSettings 
      isOpen={showCookieSettings} 
      onClose={() => setShowCookieSettings(false)} 
    />
  </footer>
  );
};

export default Footer;
